<h2 class="noMarginHeader">
  <mat-icon>cloud_download</mat-icon> Import Voucher Applications
</h2>

<section *ngIf="loading || importing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading..."></mat-progress-bar>
</section>

<section *ngIf="showSuccess">
  <br />
  <h3><strong>Voucher Successfully Imported.</strong></h3>
  <br />
  Visit the <a [routerLink]="['/dashboard']"> Dashboard <mat-icon>dashboard</mat-icon>
  </a> to view all the new applications ready for processing.
  <br />
</section>

<mat-horizontal-stepper [linear]="isLinear" #stepper labelPosition="bottom" *ngIf="!loading">

  <!-- Type of voucher -->
  <mat-step label="Voucher Type">
    <h4 style="margin-bottom:0px;">Select Voucher Type to Import</h4>
    <br />
    <br />

    <div fxFlex="100" fxFlex.lt-sm="100">
      <mat-form-field appearance="standard">
        <mat-label>Voucher Type</mat-label>
        <select [(ngModel)]="selectedVoucherType" #selectField matNativeControl width="100%">
          <option *ngFor="let item of voucherService.voucherTypesForImport" value="{{item}}">
            {{item}}
          </option>
        </select>
      </mat-form-field>
    </div>
    <br />
    <br />
    <div fxLayout="row wrap" class="matero-row">
      <span>&nbsp;&nbsp;</span>

      <button mat-raised-button color="primary" matStepperNext title="Next"
        [disabled]="selectedVoucherType == null || selectedVoucherType.length == 0"
        (click)="loadResponses()">Next</button>
    </div>
  </mat-step>

  <!-- List of Responses -->
  <mat-step label="Import Responses">
    <h4>{{selectedVoucherType}} Responses available for import ({{voucherResponses.length}})</h4>

    <mat-progress-bar mode="indeterminate" *ngIf="loadingResponses">Loading Responses...</mat-progress-bar>

    <mat-card [hidden]="loadingResponses && (selectedVoucherType != voucherService.lubgwmaTestingVoucherType || selectedVoucherType != voucherService.lubgwmatestingSurvey123VoucherType)">      
      <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
        <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
          style="overflow-x: auto;">
          <mat-header-row *matHeaderRowDef="displayedColumnsLubgwma"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumnsLubgwma;"></mat-row>
          <ng-container matColumnDef="applicationSelected">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10"></mat-header-cell>
            <mat-cell *matCellDef="let result; let i = index" fxFlex="10">
              <input type="radio" value="{{i}}" name="selectedApplicationIndex"
                (click)="setSelectedApplicationIndex(i)">
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="applicationType">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.applicationType}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="wellAddress">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Well Address</mat-header-cell>
            <mat-cell *matCellDef="let result">
              <span *ngIf="result.selectedWellId > 0">                
                {{result.wellAddress}} <br />
                {{result.wellCity}} {{result.wellState}} {{result.wellZip}} 
                <br /><br />
                <strong>OHA Well ID: {{result.selectedWellId}}</strong>
              </span>
              <span *ngIf="result.selectedWellId == 0">                
                {{result.wellAddress}} <br />
                {{result.wellCity}} {{result.wellState}} {{result.wellZip}} 
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="wellCounty">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Well County</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.wellCounty}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="wellLabelTagNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Well Tag</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.wellLabelTagNumber}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="privateWell">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Private Well</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.householdPrivateWell}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="applicantContactName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Contact Name</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.applicantContactName}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="contactHomeAddress">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Contact Home Address</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.applicantAddress}} {{result.applicantCity}} {{result.applicantZip}}<br />
              {{result.applicantCounty}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="contactMailingAddress">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Contact Mailing Address</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.mailingAddress}} {{result.mailingCity}} {{result.mailingZip}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="voucherIdentifier">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Voucher Identifer</mat-header-cell>
            <mat-cell *matCellDef="let result">
              <span *ngIf="result.selfGenerateVoucherIdentifier">{{result.selfGeneratedVoucherIdentifer}}</span>
              
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="applicationStatus">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Application Status</mat-header-cell>
            <mat-cell *matCellDef="let result">
              <span >{{result.applicationStatus}}</span>
              
            </mat-cell>
          </ng-container>
          
          <ng-container matColumnDef="debug">
            <mat-header-cell *matHeaderCellDef mat-sort-header>debug</mat-header-cell>
            <mat-cell *matCellDef="let result">
                mailing unit: {{result.applicantAddressUnit}}<br />
              
            </mat-cell>
          </ng-container>
          
        </mat-table>
        <br />
        <mat-paginator [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator"
          showFirstLastButtons></mat-paginator>
      </div>
    </mat-card>

    <mat-card *ngIf="!loadingResponses && selectedVoucherType == voucherService.wildfireVoucherType">
      <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
        <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
          style="overflow-x: auto;">
          <mat-header-row *matHeaderRowDef="displayedColumnsWildfire"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumnsWildfire;"></mat-row>
          <ng-container matColumnDef="applicationSelected">
            <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
            <mat-cell *matCellDef="let result; let i = index">
              <input type="radio" value="{{i}}" name="selectedApplicationIndex"
                (click)="setSelectedApplicationIndex(i)">
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="applicationType">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.applicationType}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="wellAddress">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Well Address</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.wellAddress}} <br />
              {{result.wellCity}} {{result.wellState}} {{result.wellZip}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="wellCounty">
            <mat-header-cell *matHeaderCellDef mat-sort-header>County</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.wellCounty}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="wellLabelTagNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Well Tag</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.wellLabelTagNumber}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="applicantContactName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Contact Name</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.applicantContactName}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="wildfires">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Wildfires</mat-header-cell>
            <mat-cell *matCellDef="let result">
              {{result.wildfire.count}}
              <ul>
                <li *ngFor="let wf of result.wildfire">{{wf | json}}</li>
              </ul>
            </mat-cell>
          </ng-container>
        </mat-table>
        <br />
        <mat-paginator  [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator"
          showFirstLastButtons></mat-paginator>
      </div>
    </mat-card>

    <br />
    <div fxLayout="row wrap" class="matero-row">
      <span>&nbsp;&nbsp;</span>
      <button mat-raised-button color="accent" matStepperPrevious title="Back">Back</button>
      &nbsp;&nbsp;
      <button mat-raised-button color="primary" matStepperNext title="Import"
        [disabled]="voucherResponses == null || voucherResponses.length == 0 || selectedApplicationIndex < 0 || importing"
        (click)="import()">Import</button>
    </div>
  </mat-step>

</mat-horizontal-stepper>